import { checkoutShouldShowBookingProtection } from 'checkout/selectors/checkoutSectionsSelectors'
import { max, sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getIsEnabledLuxPlusDiscountedBookingProtection } from 'luxPlus/selectors/featureToggle'
import getCheckoutInsuranceQuotes from 'checkout/selectors/view/getCheckoutInsuranceQuotes'
import { getBookingProtectionItemsView } from 'checkout/selectors/view/bookingProtection'
import getIsCheckoutInsuranceFetching from 'checkout/selectors/view/getIsCheckoutInsuranceFetching'

export const getAvailableBookingProtectionBenefits = createSelector(
  (state: App.State) => getIsEnabledLuxPlusDiscountedBookingProtection(state),
  (state: App.State) => checkoutShouldShowBookingProtection(state),
  (state: App.State) => getCheckoutInsuranceQuotes(state, 'booking-protection'),
  (state: App.State) => getBookingProtectionItemsView(state),
  (state: App.State) => getIsCheckoutInsuranceFetching(state),
  (
    isEnabledLuxPlusDiscountedBookingProtection,
    shouldShowBookingProtection,
    quotes,
    insuranceItemsView,
    isFetchingInsurance,
  ): App.Checkout.LuxPlusBookingProtectionBenefits => {
    const maxSavings = max(quotes.map(quote => quote.luxPlusSavings)) ?? 0

    const totalPrice = sum(insuranceItemsView.data, item => item.totals.price)
    const totalMemberPrice = sum(insuranceItemsView.data, item => item.totals.memberPrice)
    const totalMemberPriceSavings = totalPrice - totalMemberPrice

    if (!isEnabledLuxPlusDiscountedBookingProtection) {
      return {
        isAvailable: false,
        fetching: false,
        luxPlusDiscountPercentage: 0,
        luxPlusDiscountValueDisplayThreshold: 0,
        totalMemberMaxSavings: 0,
        totalMemberPriceSavings: 0,
        totalPrice: 0,
        totalMemberPrice: 0,
        totalBaseMemberPrice: 0,
      }
    }

    return {
      isAvailable: isEnabledLuxPlusDiscountedBookingProtection && shouldShowBookingProtection,
      fetching: shouldShowBookingProtection && isFetchingInsurance,
      luxPlusDiscountPercentage: quotes[0]?.luxPlusDiscountPercentage || 40,
      luxPlusDiscountValueDisplayThreshold: quotes[0]?.luxPlusDiscountValueDisplayThreshold || 30,
      totalMemberMaxSavings: maxSavings,
      totalMemberPriceSavings,
      totalPrice,
      totalMemberPrice,
      totalBaseMemberPrice: totalMemberPrice,
    }
  },
)
